import { AxiosRequestConfig, AxiosResponse } from 'axios'
import Device from '../types/Device'
import {
  Company,
  CompanyInput,
  CompanyQuery,
  CompanyVatResponse,
  EmailFromCompany,
  ActionRequest,
  RentalCompany
} from '../types'
import createAPIClient from '../services/apiClient'

const api = createAPIClient('/v2')

export async function getCompanies(
  query?: CompanyQuery,
  config?: Omit<AxiosRequestConfig, 'params'>
): Promise<Company[]> {
  const response = await api.get(`/companies`, {
    ...config,
    params: {
      showDeleted: query?.showDeleted ?? false
    }
  })

  return response.data
}

export async function getRentalCompanies(config?: AxiosRequestConfig): Promise<RentalCompany[]> {
  const response = await api.get('/companies/rental', config)

  return response.data
}

export async function getCompany(id: number, config?: AxiosRequestConfig): Promise<Company> {
  const response = await api.get(`/companies/${id}`, config)

  return response.data
}

async function createCompany(input: CompanyInput): Promise<Company> {
  const response = await api.post('/companies', input)

  return response.data
}

async function updateCompany(id: number, input: CompanyInput): Promise<Company> {
  const response = await api.put(`/companies/${id}`, input)

  return response.data
}

export async function deleteCompany(id: number, permanently = false): Promise<void> {
  await api.delete(`/companies/${id}`, {
    params: {
      permanently
    }
  })
}

export async function recoverCompany(id: number): Promise<void> {
  await api.patch(`/companies/recover/${id}`)
}

export async function sendInviteByCompany(
  id: number,
  input: EmailFromCompany
): Promise<AxiosResponse> {
  const response = await api.post(`/companies/${id}/invite`, input)
  return response.data
}

export async function getActionRequestsByCompany(id: number): Promise<ActionRequest[]> {
  const response = await api.get(`/companies/${id}/action-requests`)
  return response.data
}

export async function getCompanyDevices(id: number): Promise<Device[]> {
  const response = await api.get(`/companies/${id}/devices`)
  return response.data
}

export async function getCompanyByVat(vat: string): Promise<CompanyVatResponse> {
  const response = await api.get(`/companies/vat/${vat}`)
  return response.data
}

export async function getCompanyDescendants(
  id: number,
  config?: AxiosRequestConfig
): Promise<Company> {
  const response = await api.get(`/companies/${id}/descendants`, config)
  return response.data
}

export async function getCOmpanyHierarchy(
  id: number,
  config?: AxiosRequestConfig
): Promise<Company> {
  const response = await api.get(`/companies/${id}/hierarchy`, config)
  return response.data
}

export default {
  getCompanies,
  getCompany,
  createCompany,
  updateCompany,
  deleteCompany,
  sendInviteByCompany,
  getActionRequestsByCompany,
  getCompanyDevices,
  getCompanyByVat,
  getCompanyDescendants,
  getCOmpanyHierarchy
}
